import api from './api';

export interface Product {
  id: number;
  name: string;
  description?: string;
  sku: string;
  barcode?: string;
  category?: string;
  brand?: string;
  unit: string;
  cost_price: number;
  selling_price: number;
  tax_rate: number;
  status: 'active' | 'inactive';
  image_url?: string;
  specifications?: Record<string, any>;
  current_stock?: number;
  is_low_stock?: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateProductData {
  name: string;
  description?: string;
  sku: string;
  barcode?: string;
  category?: string;
  brand?: string;
  unit?: string;
  cost_price: number;
  selling_price: number;
  tax_rate?: number;
  status?: 'active' | 'inactive';
  image_url?: string;
  specifications?: Record<string, any>;
}

export const productService = {
  async getAll(params?: { page?: number; per_page?: number; search?: string }) {
    const response = await api.get('/products', { params });
    return response.data;
  },

  async getById(id: number): Promise<Product> {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },

  async create(data: CreateProductData): Promise<Product> {
    const response = await api.post('/products', data);
    return response.data;
  },

  async update(id: number, data: Partial<CreateProductData>): Promise<Product> {
    const response = await api.put(`/products/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/products/${id}`);
  },

  async search(query: string) {
    const response = await api.get(`/products/search/${query}`);
    return response.data;
  },
};

